import React from 'react';

// Add future team members here; each entry renders with the approved Meet The Team layout.
export const TEAM = [
  {
    key: 'quan',
    name: 'Quaniesha “Q. Nichelle” Harris',
    role: 'Operations Manager & Lead Cleaner | Gleam Guru Cleaners',
    photo: '/approved/about/quan-portrait.webp',
    photoAlt: 'Quaniesha “Q. Nichelle” Harris',
    bio: 'Quaniesha “Q. Nichelle” Harris has always been the person family and friends could count on to help clean and bring order to their homes. That experience inspired her to help others feel more comfortable and less overwhelmed in their surroundings. As Operations Manager and Lead Cleaner, she balances hands-on cleaning with bookings, service coordination, and client communication. Known for her bubbly personality, attentive nature, and determination to get things right, Quan makes listening a priority. She wants every client to feel heard, comfortable, and cared for, with a cleaner space and one less thing to worry about.',
    linkedin: 'https://www.linkedin.com/in/q-nichelle-5587ab417/',
    linkedinLabel: 'Connect with Quaniesha Harris on LinkedIn (opens in a new tab)',
  },
];

export const TeamMembers = () => TEAM.map((m) => (
  <article className="team-member" key={m.key} data-testid={`team-member-${m.key}`}>
    <div className="team-portrait"><img src={m.photo} alt={m.photoAlt} loading="lazy" /></div>
    <div className="team-member-copy">
      <h3>{m.name}</h3>
      <p className="team-role">{m.role}</p>
      <div className="team-biography"><p>{m.bio}</p></div>
      {m.linkedin && (
        <a className="profile-linkedin" href={m.linkedin} target="_blank" rel="noopener noreferrer" aria-label={m.linkedinLabel} data-testid={`team-linkedin-${m.key}`}>
          <span className="linkedin-mark" aria-hidden="true">in</span><span>Connect on LinkedIn</span><span className="linkedin-arrow" aria-hidden="true">↗</span>
        </a>
      )}
    </div>
  </article>
));
